const cca_config = {
    VUE_APP_NAME: 'ST-PHILIPPE | Stock',
    MODULE: {
        clinique: {
            port: '',  // ne pas oublier  les deux points (:),
            name: ''
        },
        caisse: {
            port: ''  // ne pas oublier  les deux points (:)
        },
        stock: {
            port: ''  // ne pas oublier  les deux points (:)
        },
        rh: {
            port: ''  // ne pas oublier  les deux points (:)
        },
    },
    C_URL: 'https://stphilippe-api.clinicaa-erp.com',
    
    C_CLINIQUE_FE_URL: 'https://stphilippe-clinique.clinicaa-erp.com',
    C_CAISSE_FE_URL: 'https://stphilippe-caisse.clinicaa-erp.com',
    C_STOCK_FE_URL: 'https://stphilippe-stock.clinicaa-erp.com',
    C_RH_FE_URL: 'https://stphilippe-rh.clinicaa-erp.com',

    C_URL_CLINIQUE_API: '/st_philippe/be_clinique/public/index.php/api',
    C_URL_CAISSE_API: '/st_philippe/be_caisse/public/index.php/api',
    C_URL_CONFIG_API: '/st_philippe/be_config/public/index.php/api',
    C_URL_STOCK_API: '/st_philippe/be_stock/public/index.php/api',

    C_URL_ASSET: '/st_philippe/be_clinique/assets',
    C_URL_CAISSE_ASSET: '/st_philippe/be_caisse/assets',
    COUNTRY_CODE: 'cm',
    VILLE: 'Douala',
    FOOT_1: '',
    FOOT_2: '',
    FOOT_ORD: '',
    PDL_PAPIER_ENTETE: '',              //  Marge intérieure gauche du papier entete
    TYPE_CLINIQUE: 'Polyclinique',
    NOM_CLINIQUE: 'POLYCLINIQUE ST-PHILIPPE',
    IS_SFE: false,
    CAN_SET_PAC: true,
    IS_MODELE_ANALYSE: true,
    PRINCIPAL_CURRENCY: 'Franc CFA',
    SECONDARY_CURRENCY: '',
    CURRENCY_LANG: 'fr-FR',
    HAS_TWO_CURRENCIES: false
}
export { cca_config }